export default __webpack_public_path__ + "a19c3c1f795141543acf8399592a92b9.svg";